<template>
  <div class="master-supplier-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i>
              <strong v-if="item.new">{{ $t('create') }}</strong>
              <strong v-else>{{ $t('edit') }}</strong>
              <div class="card-actions">
              </div>
            </div>
            <b-form class="row">
              <b-col cols="9" align-self="center">
                <b-form-group v-bind:label="$t('source_type')" :label-cols="3" :horizontal="true">
                  <v-select v-model="item.source_type" :options="source_type">
                  </v-select>
                </b-form-group>
                <b-form-group v-bind:label="$t('source_code')" :label-cols="3" :horizontal="true">
                  <v-select v-model="item.source_code" :options="source_codes">
                  </v-select>
                </b-form-group>
                <b-form-group v-bind:label="$t('destination_type')" :label-cols="3" :horizontal="true">
                  <v-select v-model="item.destination_type" :options="source_type">
                  </v-select>
                </b-form-group>
                <b-form-group v-bind:label="$t('destination_code')" :label-cols="3" :horizontal="true">
                  <v-select v-model="item.destination_code" :options="destination_codes">
                  </v-select>
                </b-form-group>
              </b-col>
            </b-form>
            <div slot="footer" class="text-center">
              <router-link :to="{name: model + '_list'}">
                <b-button variant="default"><i class="fa fa-arrow-left"></i> {{$t('back')}}</b-button>
              </router-link>
<!--              <b-button variant="success" v-on:click="updateItem" v-if="material_recipe_mapping_id != null && $auth.check(model + '.update')"><i-->
              <b-button variant="success" v-on:click="updateItem" v-if="material_recipe_mapping_id != null"><i
                class="fa fa-save"></i> {{$t('update')}}
              </b-button>
<!--              <b-button variant="success" v-on:click="createItem" v-if="material_recipe_mapping_id == null && $auth.check(model + '.create')"><i-->
              <b-button variant="success" v-on:click="createItem" v-if="material_recipe_mapping_id == null"><i
                class="fa fa-save"></i> {{$t('save')}}
              </b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
  import cSwitch from '../../../../components/Switch'
  import {get, create, update} from '@/api/master_material_recipe_mapping'
  import {getMasterMaterialList} from '@/api/master_material'
  import { getMasterRecipeList } from '@/api/master_recipe';
  export default {
    name: 'MasterMaterialRecipeMapping',
    props: {
      material_recipe_mapping_id: {
        type: String,
        default: null
      }
    },
    components: {
      cSwitch
    },
    computed: {},
    data: function () {
      return {
        model: 'master_material_recipe_mapping',
        item: {
          new: true,
          id: null,
          source_type: '',
          source_code: '',
          destination_type: '',
          destination_code: '',
          active: 1
        },
        languages: Object.keys(this.$i18n.messages),
        materials: [],
        source_type: [{label: 'Choose type', value: 0}, {label: 'Material', value: 1}, {label: 'Recipe', value: 2}],
        source_codes: [],
        destination_codes: []
      }
    },
    methods: {
      /**
       * Get List for source
       */
      getListSource (type) {
        this.$Progress.start()
        if (type === 1) {
          this.$Progress.start()
          getMasterMaterialList().then((response) => {
            for (let i in response.data.data) {
              this.source_codes.push({
                label: response.data.data[i].code + ' - ' + response.data.data[i].name,
                value: response.data.data[i].id,
                code: response.data.data[i].code
              })
            }
          }).catch((error) => {
            this.$notify({
              title: this.$t('error'),
              text: error.data.message,
              type: 'error'
            })
          }).then(() => {
            this.$Progress.finish()
          })
        } else if (type === 2) {
          getMasterRecipeList()
            .then(response => {
              for (let i in response.data.data) {
                this.source_codes.push({
                  label: response.data.data[i].code + '-' + response.data.data[i].name,
                  value: response.data.data[i].id,
                  code: response.data.data[i].code
                })
              }
            })
            .catch(error => {
              this.$notify({
                title: this.$t('error'),
                text: error.data.message,
                type: 'error'
              })
            })
            .then(() => {
              this.$Progress.finish()
            })
        }
      },
      /**
       * Get List for destination
       */
      getListDestination (type) {
        this.$Progress.start()
        if (type === 1) {
          this.$Progress.start()
          getMasterMaterialList().then((response) => {
            for (let i in response.data.data) {
              this.destination_codes.push({
                label: response.data.data[i].code + ' - ' + response.data.data[i].name,
                value: response.data.data[i].id,
                code: response.data.data[i].code
              })
            }
          }).catch((error) => {
            this.$notify({
              title: this.$t('error'),
              text: error.data.message,
              type: 'error'
            })
          }).then(() => {
            this.$Progress.finish()
          })
        } else if (type === 2) {
          getMasterRecipeList()
            .then(response => {
              for (let i in response.data.data) {
                this.destination_codes.push({
                  label: response.data.data[i].code + '-' + response.data.data[i].name,
                  value: response.data.data[i].id,
                  code: response.data.data[i].code
                })
              }
            })
            .catch(error => {
              this.$notify({
                title: this.$t('error'),
                text: error.data.message,
                type: 'error'
              })
            })
            .then(() => {
              this.$Progress.finish()
            })
        }
      },
      /**
       * Get details of object
       */
      getDetail() {
        this.$Progress.start()
        let params = {
          material_recipe_mapping_id: this.material_recipe_mapping_id
        }
        get(params).then((response) => {
          this.item = response.data.data
          this.getListSource(this.item.source_type.value)
          this.getListDestination(this.item.destination_type.value)
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },
      /**
       * Update item info to server
       */
      updateItem() {
        this.$Progress.start()
        let param = {}
        param.id                    = this.material_recipe_mapping_id
        param.source_type           = this.item.source_type.value
        param.source_id             = this.item.source_code.value
        param.source_code           = this.item.source_code.code
        param.destination_type      = this.item.destination_type.value
        param.destination_id        = this.item.destination_code.value
        param.destination_code      = this.item.destination_code.code
        update(param).then((response) => {
          this.$notify({
            title: this.$t('success'),
            text: response.data.message,
            type: 'success'
          })
          this.$router.push({name: this.model})
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },
      /**
       * Create item info to server
       */
      createItem() {
        this.$Progress.start()
        let param = {}
        param.source_type           = this.item.source_type.value
        param.source_id             = this.item.source_code.value
        param.source_code           = this.item.source_code.code
        param.destination_type      = this.item.destination_type.value
        param.destination_id        = this.item.destination_code.value
        param.destination_code      = this.item.destination_code.code
        create(param).then((response) => {
          this.$notify({
            title: this.$t('success'),
            text: response.data.message,
            type: 'success'
          })
          this.$router.push({name: this.model})
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      }
    },
    created: function () {
      if (this.material_recipe_mapping_id != null) {
        this.item.new = false
        this.getDetail()
      } else {
        this.item.material_recipe_mapping_id = ''
      }
    },
    watch: {
      'item.source_type': function () {
        this.source_codes = []
        if (this.item.source_type.value !== 0) {
          this.getListSource(this.item.source_type.value)
        }
      },
      'item.destination_type': function () {
        this.destination_codes = []
        if (this.item.destination_type.value !== 0) {
          this.getListDestination(this.item.destination_type.value)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/admin/inventory/master_material_recipe_mapping/Form.vue